module.exports = __webpack_public_path__ + "static/media/authorize-aspnet-core-apps.674c5d74.md";